import React, { useEffect, useState, useCallback, use } from "react";
import { Card, Button } from "react-bootstrap";
import { apiRoutes, routes } from "../../routes/routes";
import { useNavigate } from "react-router-dom";
import api from "../../api";
import { Itinerary, ItineraryData, Message } from "../../types";
import LoadingMessage from "../LoadingMessage";
import ItineraryCard from "./ItineraryCard";
import { getImages, updateItinerary } from "../../functions/Query";
import {
  create_content_from_output,
  llmTextSeparator,
} from "../../functions/ItineraryUtils";
import MarkdownViewer from "../MarkdownViewer";

interface ItineraryParams {
  destination: string;
  duration: string;
  prompt: string;
}

interface Props {
  message: Message;
  params: ItineraryParams;
}

const ItineraryChatMessage: React.FC<Props> = ({ message, params }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [itinerary, setItinerary] = useState<Itinerary | null>(null);

  const messageUuid = message.uuid;

  const saveItinerary = async (itinObj: Itinerary) => {
    try {
      const response = await api.post(
        apiRoutes.itineraries,
        {
          title: itinObj.data.title,
          message_uuid: messageUuid,
          data: itinObj.data,
        },
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      itinObj = response.data;
      // message.parsed = null;
    } catch (err) {}
  };

  const updateMessage = async (message: Message, content: string) => {
    if (!message.uuid) return false;

    const url = apiRoutes.message_details.replace(":uuid", message.uuid);

    message.content = message.content + llmTextSeparator + content;

    api.patch(url, { content: message.content });
  };

  const fetchItinerary = async () => {
    setLoading(true);
    setError(null);

    try {
      if (!message.itineraries || message.itineraries?.length == 0) {
        // First time the itinerary is generated => save it

        const response = await api.post(apiRoutes.itinerary2, {
          params: params,
        });

        // await getImages(message.parsed);

        const itinObj: Itinerary = {
          created_at: null,
          data: response.data.itinerary,
          title: null,
          uuid: null,
          description: null,
        };

        // message.parsed.is_new = false;
        // await saveItinerary(itinObj);

        message.itineraries = [itinObj];

        setItinerary(itinObj);

        if (response.data.message) {
          // setContent(response.data.message);
          message.content = response.data.message;
        }

          if (messageUuid) {
            await updateMessage(message, create_content_from_output(itinObj));
          }

        if (!itinObj.data.images) {
          await getImages(itinObj.data);

          await saveItinerary(itinObj);
        }
      } else {
        if (message.itineraries) {
          const itinObj: Itinerary = message.itineraries[0];
          setItinerary(itinObj);
        }

        // if(message.parsed){
        //   const itinObj: Itinerary = {
        //   created_at: null,
        //   data: message.parsed,
        //   title: null,
        //   uuid: null,
        //   description: null,
        // };
        //   setItinerary(itinObj);
        // }
      }

      // if(intent === "update") {
      //   updateItinerary()
      // }
    } catch (err) {
      setError("Une erreur est survenue lors de la création de l'itinéraire.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchItinerary();
  }, []);

  return (
    <div>
      {loading && (
        <Card className="my-4 shadow">
          <Card.Body>
            <div>
              <Card.Title>Nous préparons votre itinéraire</Card.Title>
              <LoadingMessage />
            </div>
          </Card.Body>
        </Card>
      )}

      {itinerary && (
        <>
          {/* {content && <MarkdownViewer content={content} />} */}

          <ItineraryCard itinerary={itinerary} />
        </>
      )}
    </div>
  );
};

export default ItineraryChatMessage;
